export default {
  geolocation: {
    lat: '59.9138',
    lng: '10.7522',
    label: '0001 Oslo',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
